import type { TaskStatus, WorkTask } from "../domain/operations";
import { taskStatusLabels } from "../domain/operations";

const statuses: TaskStatus[] = ["eligible", "scheduled", "in_progress", "blocked", "complete"];

export function TaskStatusSelect({
  task,
  onStatus,
}: {
  task: WorkTask;
  onStatus: (taskId: string, status: TaskStatus, blockerNote?: string) => void;
}) {
  return (
    <select
      className="status-select"
      aria-label={`Change status for ${task.title}`}
      value={task.status}
      onChange={(event) => {
        const status = event.target.value as TaskStatus;
        onStatus(task.id, status, status === "blocked" ? task.blockerNote || "Flagged blocked" : undefined);
      }}
    >
      {statuses.map((status) => (
        <option key={status} value={status}>{taskStatusLabels[status]}</option>
      ))}
    </select>
  );
}
